document.addEventListener('turbolinks:load', function () {
    flatpickr(".date-picker", {
        altInput: true,              // shows a formatted UI input
        altFormat: "m/d/Y",          // format shown to the user
        dateFormat: "Y-m-d",         // value stored in input and sent to backend
        allowInput: true
    });
});